import Icon from '@material-ui/icons/GroupWork';

import List from './List';

export default {
  name: 'reports/season',
  icon: Icon,
  list: List,
};
